import { Loader, Text } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './lots-validation.module.css';

export interface LotsStatsHeaderProps {
  total: number | undefined;
  pending: number | undefined;
  validated: number | undefined;
  isLoading?: boolean;
}

export const LotsStatsHeader: FC<LotsStatsHeaderProps> = ({
  total,
  pending,
  validated,
  isLoading,
}) => {
  const { t } = useTranslation();

  const formatCount = (value: number | undefined) => {
    if (isLoading && value === undefined) {
      return <Loader color="gray" size="sm" type="dots" />;
    }
    if (value === undefined) {
      return '—';
    }
    return value.toLocaleString('fr-FR');
  };

  return (
    <div className={classes.statsBox}>
      <div className={classes.statBlock}>
        <Text className={classes.statValue} component="div">
          {formatCount(total)}
        </Text>
        <Text className={classes.statLabel}>{t('lots.stats.total_label')}</Text>
      </div>
      <div className={classes.statBlock}>
        <Text className={classes.statValue} component="div">
          {formatCount(pending)}
        </Text>
        <Text className={classes.statLabel}>
          {t('lots.stats.pending_label')}
        </Text>
      </div>
      <div className={classes.statBlock}>
        <Text
          className={`${classes.statValue} ${classes.statValueValidated}`}
          component="div"
        >
          {formatCount(validated)}
        </Text>
        <Text className={classes.statLabel}>
          {t('lots.stats.validated_label')}
        </Text>
      </div>
    </div>
  );
};

export default LotsStatsHeader;
